// extracted by mini-css-extract-plugin
export default {"errorTitle":"errorComponent_errorTitle__cWh2W"};